<template>
  <div class="idea-block">
    <div 
      v-show="!isFilled"
      class="idea-block__wrapp"
    >
      <div class="idea-block__name">
        <div class="idea-block__title">
          {{ nameTitle + id }}
        </div>
    
        <div class="idea-block__description">
          {{ nameDescription }}
        </div>
    
        <BaseInput
          minLength="1"
          :maxLength="'30'"
          :value="value.name"
          errorMsg="Поле заповнене некоректно"
          placeholder="Назвіть вашу ідею"
          type="text"
          class="service-request-page__form-input"
          @input="updateData($event, 'name')"
        />
      </div>
    
      <div class="idea-block__info">
        <div class="idea-block__title">
          {{ descriptionTitle }}
        </div>
    
        <div class="idea-block__description">
          {{ descriptionInfo }}
        </div>
    
        <BaseInput
          minLength="1"
          maxLength="2500"
          type="textarea"
          :value="value.description"
          errorMsg="Поле заповнене некоректно"
          class="service-request-page__form-input"
          @input="updateData($event, 'description')"
        />
      </div>
    
      <div class="idea-block__row">
        <div class="idea-block__description">
          {{ fileInfo }}
        </div>
    
        <BaseFile
          v-model="files"
          @input="updateData($event, 'files')"
        />
      </div>
    
      <div class="idea-block__row">
        <div class="idea-block__col">
          <div class="idea-block__title">
            Тип файлу
          </div>
    
          <div class="idea-block__hint">
            (Можна вибрати декілька)
          </div>
    
          <div class="idea-block__file-type">
            <div
              v-for="(item,index) in typesFile"
              :key="index"
              class="checkboxes-block"
              @input="updateData($event, 'TypeFileIds')"
            >
              <label
                class="checkboxes-block__label"
              >
                <input
                  :id="item.id"
                  v-model="TypeFileIds"
                  class="checkboxes-block__input"
                  type="checkbox"
                  :value="item"
                  name="TypeFileIds"
                >
    
                <div class="checkboxes-block__icon" />
    
                {{ item.title }}
              </label>
            </div>
          </div>
        </div>
    
        <div class="idea-block__col">
          <div class="idea-block__title">
            Клас учнів
          </div>
    
          <div class="idea-block__hint">
            (Можна вибрати декілька)
          </div>
    
          <div class="idea-block__file-type">
            <div
              v-for="(item,index) in classStudents"
              :key="index"
              class="checkboxes-block"
            >
              <label
                class="checkboxes-block__label"
              >
                <input
                  :id="item.id"
                  v-model="ClassStudentsIds"
                  class="checkboxes-block__input"
                  type="checkbox"
                  name="ClassStudentsIds"
                  :value="item"
                >
    
                <div class="checkboxes-block__icon" />
    
                {{ item.title }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div 
      v-show="isFilled"
      class="idea-block__wrapp"
    >
      <div class="idea-block__title">
        {{ nameTitle + id }}
      </div>

      <div class="idea-block__name_filled">
        {{ value.name }}
      </div>

      <div class="idea-block__description_filled">
        {{ smallDescription }}
      </div>

      <div class="idea-block__file_filled">
        <div 
          v-for="(file, index) in files"
          :key="index"
          class="idea-block__files"
        >
          <Clip />
          <span>{{ file.name }}</span>
        </div>
      </div>
      <div class="idea-block__row idea-block__row_filled">
        <div 
          v-if="TypeFileIds.length > 0"
          class="idea-block__col"
        >
          <div class="idea-block__title_filled">
            Тип файлу:
          </div>
          <ul class="idea-block__file-type_filled">
            <li
              v-for="(item,index) in TypeFileIds"
              :key="index"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>

        <div 
          v-if="ClassStudentsIds.length > 0"
          class="idea-block__col"
        >
          <div class="idea-block__title_filled">
            Клас учнів:
          </div>
          <ul class="idea-block__file-type_filled">
            <li
              v-for="(item,index) in ClassStudentsIds"
              :key="index"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>

      <div class="idea-block__btns">
        <BaseButton
          @click.native.prevent="editIdea()"
        >
          Редагувати
        </BaseButton>

        <BaseButton
          theme="white"
          @click.native.prevent="removeIdea()"
        >
          Видалити
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
  import Clip from '@/assets/svg/clip.svg'
  export default {
    name: 'StepOneItem',

    components: { Clip },

    props: {
      nameTitle: {
        type: String,
        default: ''
      },
      nameDescription: {
        type: String,
        default: ''
      },
      descriptionTitle: {
        type: String,
        default: ''
      },
      descriptionInfo: {
        type: String,
        default: ''
      },
      fileInfo: {
        type: String,
        default: ''
      },
      classStudents: {
        type: Array,
        default: () => []
      },
      typesFile: {
        type: Array,
        default: () => []
      },
      id: {
        type: Number,
        default: 1
      },
      value: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        IdeaName: '',
        IdeaDescription: '',
        isFilled: false,
        smallDescription: '',
        files: [],
        TypeFileIds: [],
        ClassStudentsIds: []
      }
    },

    watch: {
      value: {
        deep: true,
        handler () {
          if (this.value.description.length <= 200) {
            this.smallDescription = this.value.description
          } else {
            this.smallDescription = this.value.description.slice(0, 200) + '...'
          }
        }
      }
    },
    created () {
      this.bus.$on('addNewIdea', (data) => {
        this.isFilled = true
      })
    },

    methods: {
      inputValue (e) {
        return e
      },
      updateData (e, key) {
        const newData = { ...this.value }

        newData[key] = e
        this.$emit('input', newData)
        // console.log(e, key)
      },

      removeIdea () {
        this.$emit('remove')
      },

      editIdea () {
        this.isFilled = false
      }
    }
    
  }
</script>

<style lang="scss">
.idea-block {
  position: relative;

  &__title {
    font-size: 32px;
    font-weight: 700;
    line-height: 1.18;
    text-transform: uppercase;
    margin-bottom: 22px;
    color: $c-black;

    @include mobile {
      font-size: 20px;
      line-height: 1.18;
      margin-bottom: 12px;
    }

    &_filled {
      font-size: 12px;
      line-height: 1.25;
      color: #6e6e6e;
      margin-bottom: 4px;
    }
  }

  &__hint {
    font-size: 14px;
    line-height: 1.25;
    margin-bottom: 30px;
    margin-top: -20px;

    @include mobile {
      font-size: 12px;
      line-height: 18px;
      margin-top: -12px;
    }
  }

  &__description {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 22px;
    color: $c-light-black;

    @include mobile {
      font-size: 14px;
      line-height: 1.18;
      margin-bottom: 12px;
    }

    &_small {
      width: 100%;
      max-width: 365px;
    }

    &_filled {
      font-size: 24px;
      line-height: 1.34;
      color: #686868;
      margin-bottom: 18px;

      @include mobile {
        font-size: 18px;
        line-height: 1.34;
        margin-bottom: 12px;
      }
    }
  }

  &__name {
    margin-bottom: 38px;

    @include mobile {
      margin-bottom: 30px;
    }

    &_filled {
      font-size: 24px;
      font-weight: 500;
      line-height: 1.34;
      color: $c-black;
      margin-bottom: 18px;

      @include mobile {
        font-size: 18px;
        line-height: 1.34;
        margin-bottom: 12px;
      }
    }
  }

  &__file {
    &_filled {
      display: flex;
      flex-direction: column;
      margin-bottom: 26px;
    }
  }

  &__files {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      margin-left: 13px;
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      color: $c-yellow;
    }
  }

  &__file-type {
    &_filled {
      list-style: none;

      li {
        font-size: 18px;
        line-height: 1.34;
        margin-bottom: 5px;
      }
    }
  }

  &__info {
    margin-bottom: 22px;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 88px;

    @include mobile {
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-bottom: 32px;
    }

    &_filled {
      margin-bottom: 0;
    }
  }

  &__btns {
    margin-top: 48px;
    margin-bottom: 88px;
    padding-bottom: 40px;
    border-bottom: 2px solid #dbdbdb;

    @include mobile {
      display: flex;
      justify-content: space-between;
    }

    button {
      min-width: 210px;
      height: 56px;
      

      &:first-child {
        margin-right: 20px;
      }

      @include mobile {
        min-width: calc(50% - 8px);
        margin: 0 !important;
      }
    }
  }

  &__col {
    width: calc(50% - 26px);

    @include mobile {
      width: 100%;

      &:not(:last-child) {
        margin-bottom: 32px;
      }
    }
  }
}

.checkboxes-block {
  position: relative;
  display: flex;

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  &__label {
    display: flex;
  }

  &__input {
    display: none;

    &:checked + .checkboxes-block__icon {
      background-color: #FDE8CC;
      border-color: #FDE8CC;

      &::before {
        opacity: 1;
      }
    }
  }

  &__icon {
    position: relative;
    width: 16px;
    height: 16px;
    border: 2px solid #dbdbdb;
    margin-right: 14px;
    transition: 0.3s;

    &::before {
      position: absolute;
      top: 0px;
      left: 4px;
      width: 5px;
      height: 9px;
      border-right: 2px solid $c-orange;
      border-bottom: 2px solid $c-orange;
      opacity: 0;
      transition: 0.3s;
      content: '';
      transform: rotate(45deg);
    }
  }

    @include hover {
    .checkboxes-block__icon {
      border-color: $c-yellow;
    }
  }
}
</style>
